import { createFileRoute } from '@frontend/web/utils/router';

export const Route = createFileRoute('/app/settings')({});
